{
	"title": "Стрик обучения",
	"current": "{days, plural, one {# день} few {# дня} many {# дней} other {# дня}}",
	"currentSuffix": "подряд",
	"longest": "Рекорд",
	"longestValue": "{days, plural, one {# день} few {# дня} many {# дней} other {# дня}}",
	"dailyGoal": "Цель",
	"dailyGoalValue": "{minutes} мин/день",
	"nextMilestone": "До цели {days, plural, one {# день} few {# дня} many {# дней} other {# дня}}",
	"freezes": {
		"title": "Заморозки",
		"balance": "{count, plural, one {# заморозка} few {# заморозки} many {# заморозок} other {# заморозки}} в запасе",
		"usedThisWeek": "Использовано на этой неделе: {count}",
		"useManual": "Заморозить вручную",
		"about": "О заморозках",
		"aboutText": "Заморозка сохраняет серию за день без занятий. Начисляются автоматически (1 в неделю). Если есть запас — нажми «Заморозить вручную», чтобы закрыть пропущенный день.",
		"none": "Сейчас в запасе нет заморозок — начисляется 1 в неделю (по понедельникам).",
		"applied": "Заморозка применена"
	},
	"heatmap": {
		"title": "Последние 30 дней",
		"today": "Сегодня",
		"cellMinutes": "{count, plural, one {# мин} few {# мин} many {# мин} other {# мин}}",
		"frozenCell": "Серия сохранена заморозкой",
		"legend": {
			"done": "выполнено",
			"frozen": "заморожено",
			"missed": "пропущено"
		}
	},
	"settings": {
		"timezone": "Часовой пояс",
		"reminder": "Напоминание",
		"edit": "Изменить настройки",
		"open": "К настройкам"
	},
	"states": {
		"atRiskTitle": "Стрик под угрозой",
		"atRiskBody": "Сделай хотя бы 1 повторение или используй заморозку",
		"brokenTitle": "Стрик прерван",
		"brokenBody": "Прошлый рекорд: {days, plural, one {# день} few {# дня} many {# дней} other {# дней}}. Начни новый — небольшая привычка возвращает результат за неделю.",
		"milestoneTitle": "Достижение! {days, plural, one {# день} few {# дня} many {# дней} other {# дней}} подряд",
		"milestoneBody": "Так держать."
	},
	"actions": {
		"close": "Закрыть",
		"studyNow": "Изучать сейчас",
		"share": "Поделиться",
		"continue": "Продолжить"
	},
	"dialog": {
		"title": "Стрик",
		"description": "Удержи серию обучения каждый день",
		"current": "Текущий",
		"longest": "Лучший",
		"dailyGoal": "Дневная цель",
		"autoFreeze": "Авто-заморозка 1×/неделя",
		"freezeBalance": "Доступно заморозок: {count}",
		"history30d": "Последние 30 дней",
		"minutesShort": "{count, plural, one {# мин} few {# мин} many {# мин} other {# мин}}"
	},
	"banner": {
		"freezeApplied": "Freeze применён за последнюю неделю — стрик не потерян"
	},
	"indicator": {
		"daysLabel": "дней",
		"aria": "Серия обучения: {days, plural, one {# день} few {# дня} many {# дней} other {# дней}}"
	}
}
